import '../globals';

/* global css imports */
import 'angular/angular-csp.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'ui-select/dist/select.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import '../css/nga.all.min.css';
import '../json-tree2/json-tree-custom.less';
import 'angularjs-toaster/toaster.css';

import '../css/site.less';

/* angular modules */
import * as angular from 'angular';
import * as ngAnimate from 'angular-animate';
import * as ngSanitize from 'angular-sanitize';

/* 3p modules */
import 'ngstorage';
import {ngStorage} from 'ngstorage';
import 'angular-filter';
import 'angular-moment';
import 'ui-select';
import 'angular-ui-bootstrap';
import uirouter, {StateService} from '@uirouter/angularjs';
import 'angular-credit-cards';
import '../json-tree2/json-tree-custom.js';
import 'angularjs-toaster';

/* our modules */
import RoutingModule from '../modules/RoutingModule';
import ApiModule from '../modules/ApiModule';
import ConfigModule, {ConfigService} from '../modules/ConfigModule';
import DebounceModule from '../modules/DebounceModule';
import HubProxyModule from '../modules/HubProxyModule';
import SpinnerModule from '../modules/SpinnerModule';
import PrintModule from '../modules/PrintModule';
import MenuModule from "../modules/MenuModule";
import DataHubModule from "../modules/DataHubModule";
import UserStorageModule from "../modules/UserStorageModule";

import HomeModule from './home/index';
import LoginModule from './login';
import DeveloperModule from './developer';
import LeadModule from './lead';
import CustomerModule from './customer';
import CaseModule from './case';
import CompanyModule from './company'
import LicenseModule from './license';
import PaymentModule from './payment';
import InvoiceModule from './invoice';
import ImportModule from './import';
import TxnTemplateModule from './txnTemplate';
import ActivityModule from './activity';

/* directives */

import ComponentsModule from '../component';
import DirectivesModule from '../directive';

import UserActivityModule, {UserActivityService} from "../modules/UserActivityModule";

import 'json.date-extensions';
// @ts-ignore
JSON.useDateParser();

angular.module('app',
    [
        /* angular modules */
        ngSanitize, ngAnimate,

        /* 3p modules */
        'ngStorage', 'angular.filter', 'angularMoment', 'ui.select', 'ui.bootstrap',
        'credit-cards',
        'json-tree',
        'toaster',
        uirouter,

        /* routing must be initialized first */
        RoutingModule,
        /* our modules */
        ApiModule,
        ConfigModule,
        DebounceModule,
        HubProxyModule,
        SpinnerModule,
        PrintModule,
        MenuModule,
        DataHubModule,
        UserStorageModule,
        DeveloperModule,
        UserActivityModule,
        ComponentsModule,
        DirectivesModule,

        HomeModule,
        LoginModule,
        LeadModule,
        ActivityModule,
        CustomerModule,
        CaseModule,
        CompanyModule,
        LicenseModule,
        PaymentModule,
        InvoiceModule,
        ImportModule,
        TxnTemplateModule
    ])
    .config(uiSelectConfig => {
        uiSelectConfig.theme = 'bootstrap';
    })
    .config((moment) => {
        moment.updateLocale('en', {
            week: {
                dow: 0,
                doy: 7
            }
        });
    })
    .config(($httpProvider: ng.IHttpProvider) => {
        // $httpProvider.interceptors.push(authInterceptor);
        $httpProvider.defaults.withCredentials = true;
    })
    .config(($sceDelegateProvider) => {
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'data:text**'
        ])
    })
    .run((
        $rootScope: ng.IRootScopeService,
        $localStorage: ngStorage.StorageService,
        $state: StateService,
        $config: ConfigService,
        $userActivity: UserActivityService,
        $interval: ng.IIntervalService) => {
        var timeAppLoaded = new Date();
        var ls = $localStorage;
        $rootScope['$config'] = $config;
        $rootScope['$state'] = $state;

        $rootScope.$watch(() => ls.loginTimestamp,
            () => {
                var isLoggedIn = ls.loggedIn;
                var timeLoginUpdated = new Date(ls.loginTimestamp);
                //console.debug('loginTimestamp updated.', timeLoginUpdated, 'isLoggedIn:', isLoggedIn);

                if (isLoggedIn && $state.is('login')) {
                    //console.debug('go to home');
                    $state.go('home')
                } else if (!isLoggedIn && timeLoginUpdated > timeAppLoaded) {
                    console.error('logout triggered via local storage');
                    // close window if possible
                    if (window.parent && window.parent !== window)
                        window.close();
                    // otherwise go to login
                    if (!$state.is('login')) {
                        //console.debug('go to login');
                        $state.go('login');
                    }
                }
            });

        // keep login alive by pinging server every 30s
        $interval(() => {
            if (!ls.loggedIn) return;
            $config.checklogin().catch();

        }, 30000);
        $config.checklogin().catch();




    });

